module.exports = __webpack_public_path__ + "img/ic_mpe_chair_sm1_press.dc3f7113.png";